import React from 'react';
import PropTypes from 'prop-types';

import Spacing from '@marvelapp/marvel-ui/spacing';
import Image from 'marketing-website/components/modules/Image';

export default function MediaMultipleImages({
  children,
  fallbackImageAlt,
  fallbackImageMaxWidth,
  fallbackImageSrc,
}) {
  const maxWidth = fallbackImageMaxWidth;
  const fallbackImageProps = {
    alt: fallbackImageAlt,
    hasShadow: false,
    maxWidth,
    src: fallbackImageSrc,
  };
  return (
    <div>
      <div className="display-block breakPointM-display-none">
        <div className="centered" style={{ maxWidth }}>
          {fallbackImageSrc && (
            <Spacing size="l" type="padding" position="bottom">
              <Image {...fallbackImageProps} />
            </Spacing>
          )}
        </div>
      </div>
      <div className="aspectRatio aspectRatio--100 display-none breakPointM-display-block">
        <div className="aspectRatio-content">{children}</div>
      </div>
    </div>
  );
}

MediaMultipleImages.propTypes = {
  children: PropTypes.node.isRequired,
  fallbackImageAlt: PropTypes.string,
  fallbackImageMaxWidth: PropTypes.number,
  fallbackImageSrc: PropTypes.string,
};

MediaMultipleImages.defaultProps = {
  fallbackImageMaxWidth: 768,
};



// WEBPACK FOOTER //
// ./src/components/modules/Media/MediaMultipleImages/index.js